import React from "react"

export const getBlockchainDetails = () => {
  return {
    RPC: `${process.env.NEXT_PUBLIC_WEB3_RPC}`,
    network: `${process.env.NEXT_PUBLIC_WEB3_NETWORK}`,
    networkID: `${process.env.NEXT_PUBLIC_NETWORK_ID}`,
    contract: `${process.env.NEXT_PUBLIC_NFT_ADDRESS}`,
    opensea: `${process.env.NEXT_PUBLIC_OPENSEA}`,
  }
}

export const getBlockchainNetwork = (web3: any) => {
  const _nativeCurrency = {
    name: "MATIC",
    symbol: "MATIC",
    decimals: 18,
  }
  const blockchainDetails = getBlockchainDetails()
  return process.env.NEXT_PUBLIC_NETWORK_ID == "80001"
    ? {
        chainId: web3.utils.toHex(blockchainDetails.networkID),
        chainName: "Mumbai Testnet",
        nativeCurrency: _nativeCurrency,
        //change RPC to https://matic-testnet-archive-rpc.bwarelabs.com if "RPC Error: Chain ID returned by RPC URL https://rpc-mumbai.matic.today does not match 0x13881"
        //change RPC to https://rpc-mumbai.matic.today                  if "RPC Error: Chain ID returned by RPC URL https://rpc-mumbai.matic.today does not match 0x13881"
        //or use any other from https://chainlist.org/ -> Enable Testnets -> Mumbai -> Chevron down -> RPC Server Address"
        rpcUrls: ["https://matic-testnet-archive-rpc.bwarelabs.com"],
        blockExplorerUrls: ["https://mumbai.polygonscan.com"],
      }
    : {
        chainId: web3.utils.toHex(blockchainDetails.networkID),
        chainName: "Polygon",
        nativeCurrency: _nativeCurrency,
        rpcUrls: ["https://polygon-rpc.com"],
        blockExplorerUrls: ["https://www.polygonscan.com"],
      }
}
